import React from 'react';
import './TestimonialsSection.css';

const testimonials = [
  {
    stars: 5,
    text: '"Got my biggest refund ever! Fast and professional. They found deductions I didn\'t even know I had. I\'ll never go anywhere else for my taxes."',
    name: 'Marcus J.',
    role: 'W-2 Employee, Chicago IL',
    initial: 'M',
  },
  {
    stars: 5,
    text: '"Very knowledgeable with Uber taxes. They knew exactly what mileage and expenses I could deduct. Got way more back than I expected!"',
    name: 'David R.',
    role: 'Uber Driver, Evanston IL',
    initial: 'D',
  },
  {
    stars: 5,
    text: '"Helped me fix my IRS issue quickly. I had a CP2000 notice and didn\'t know what to do. They resolved it in days. Highly recommend!"',
    name: 'Sandra T.',
    role: 'Small Business Owner',
    initial: 'S',
  },
];

const TestimonialsSection = () => (
  <section className="section section-alt" id="testimonials">
    <div className="container">
      <div className="section-header">
        <div className="section-label">Client Reviews</div>
        <h2 className="section-title">
          What Our Clients <em>Say About Us</em>
        </h2>
        <p className="section-subtitle">
          Hundreds of satisfied clients across all 50 states trust A-Mobile Tax Services every filing season.
        </p>
      </div>
      <div className="testimonials-grid">
        {testimonials.map((t) => (
          <div className="testimonial-card" key={t.name}>
            <div className="testimonial-quote">"</div>
            <div className="stars">{'⭐'.repeat(t.stars)}</div>
            <p className="testimonial-text">{t.text}</p>
            <div className="testimonial-author">
              <div className="author-avatar">{t.initial}</div>
              <div>
                <div className="author-name">{t.name}</div>
                <div className="author-role">{t.role}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TestimonialsSection;
